import { render, staticRenderFns } from "./DadosGrupo.vue?vue&type=template&id=2c2dd312"
import script from "./DadosGrupo.vue?vue&type=script&lang=js"
export * from "./DadosGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports